import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import {CommonConstants} from "../shared/constants/common-constants.enum";
import {AuthService} from "../authentication/service/auth.service";

@Injectable()
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isAdmin = localStorage.getItem(CommonConstants.IS_ADMIN) === 'true';
    if(isAdmin) {
      return of(true);
    } else {
      this.router.navigate(['/meter-cooperative']).finally();
      return of(false);
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.of(true);
  }
}
